// Module
var code = "<wt-modern-group-script-contextual group=\"vm.selectedGroup\" is-code-editor-disabled=\"vm.isCodeEditorDisabled\" outside-form-controller=\"vm.codeFormController\" script-test-mode=\"vm.selectedScriptTestMode\"> </wt-modern-group-script-contextual>";
// Exports
module.exports = code;